import type { Translate } from "app/filters/i18nFilter";
import type { IApiHelper } from "app/common/services/apiHelper";
import type { DefaultFetchService } from "app/services/fetchService";
import type { AggregatedTracker } from "@similarweb/sw-track";
import { createContext } from "react";
import type { DurationService } from "app/services/DurationService";
import type { UserCustomCategoryService } from "app/services/category/userCustomCategoryService";
import type categoryService from "app/common/services/categoryService";
import type { NavigatorType } from "single-spa/react-app/ProNavigator";

export interface IServices {
    translate: Translate;
    navigator: NavigatorType;
    apiHelper: IApiHelper;
    tracker: AggregatedTracker;
    fetchService: DefaultFetchService;
    durationService: DurationService;
    categoryService: typeof categoryService;
    customCategoryService: typeof UserCustomCategoryService;
}

interface IIndustryOverviewContext {
    services: IServices;
}

export const IndustryOverviewContext = createContext<IIndustryOverviewContext>({
    services: null,
});
